import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Login from './Login/Login';
import Check from './Check';

function PublicRoutes() {
    return (
        <Switch>
            <Route path="/signin" exact component={Login} />
            <Route path="/check" exact component={Check} />
            <Route component={Login}/>
        </Switch>
    );
}

export default PublicRoutes;
